import { ocupationByBranchId, placeAtention } from "../../helpers/fetching";

export default {
  state: {
    branchesInfoCompany: [],
    profileData: [],
    loading: false,
    error: null,
    ocupationError: false,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setProfile(state, data) {
      state.profileData = data;
      state.loading = false;
      state.error = null;
    },
    setBranchesInfoCompany(state, data) {
      state.branchesInfoCompany = data;
      state.loading = false;
      state.error = null;
    },
    setOcupationError(state, data) {
      state.ocupationError = data;
    },
  },
  actions: {
    profileGetActionById({ commit }, id) {
      if (!id) return;
      commit("clearError");
      commit("setLoading", true);
      placeAtention(id)
        .then((response) => {
          commit("setProfile", response);
        })
        .catch((error) => {
          commit("setError", !!error);
        });
    },
    getCompanyBranchesInfo({ commit, state }, id) {
      if (state.ocupationError) return;
      if (!id) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        location.reload();
      }
      ocupationByBranchId(id)
        .then((result) => {
          commit("setBranchesInfoCompany", result);
        })
        .catch((error) => {
          console.error(error);
          // autoRefreshToken();
          commit("setOcupationError", true);
        });
    },
    clearAllData({ commit }) {
      commit("clearError");
      commit("setLoading", false);
      commit("setProfile", null);
    },
  },
};
